function shuffle(array) {
  const arr = [...array];
  let i = arr.length;
  while (i > 0) {
    const j = Math.floor(Math.random() * i--);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function filterWordList(words, userInput) {
  var list = words.flat();

  if (userInput.shuffle) list = shuffle(list);

  if (userInput.includes) {
    const parts = userInput.includes.toUpperCase().split(",");
    list = list.filter((w) =>
      parts.every((p) => w.toUpperCase().includes(p.trim()))
    );
  }

  if (userInput.excludes) {
    const parts = userInput.excludes.toUpperCase().split(",");
    list = list.filter((w) =>
      parts.every((p) => !w.toUpperCase().includes(p.trim()))
    );
  }

  if (userInput.wordLen) {
    const len = parseInt(userInput.wordLen);
    list = list.filter((w) => w.length === len);
  }

  if (userInput.presets.includes("q_no_u")) {
    list = list.filter(
      (w) => w.toUpperCase().includes("Q") && !w.toUpperCase().includes("U")
    );
  }
  if (userInput.presets.includes("palindrome")) {
    list = list.filter(
      (w) =>
        w.toUpperCase().split("").reverse().join("") === w.toUpperCase()
    );
  }
  if (userInput.presets.includes("no_vowels")) {
    list = list.filter((w) => !/[AEIOU]/i.test(w));
  }
  if (userInput.presets.includes("7l5v")) {
    list = list.filter(
      (w) => w.length === 7 && (w.match(/[AEIOU]/gi) || []).length >= 5
    );
  }
  if (userInput.presets.includes("5l4v")) {
    list = list.filter(
      (w) => w.length === 5 && (w.match(/[AEIOU]/gi) || []).length === 4
    );
  }
  if (userInput.presets.includes("satine")) {
    list = list.filter(
      (w) =>
        w.length === 7 &&
        "SATINE".split("").every((c) => w.toUpperCase().includes(c))
    );
  }
  if (userInput.presets.includes("endinz")) {
    list = list.filter((w) => w.toUpperCase().endsWith("Z"));
  }

  return list.length > 0 ? list : ["You filtered too much..."];
}
